<template>
    <li
        v-if="$can(item.action, item.resource)"
        :id="`nav-item-${item.route}`"
        :class="{
            active: isActive,
            disabled: item.disabled,
        }"
        class="nav-item"
    >
        <b-link class="d-flex align-items-center" v-bind="linkProps">
            <template v-if="counter">
                <font-awesome-icon :icon="item.icon" />
                <b-badge class="bg-additional text-white position-absolute shadow-additional mainmenu">
                    {{ counter }}
                </b-badge>
            </template>

            <font-awesome-icon v-else :icon="item.icon" />
            <span class="menu-title text-truncate">{{ t(item.title) }}</span>
        </b-link>
    </li>
</template>

<script>
import { useUtils as useAclUtils } from "@core/libs/acl";
import { BAvatar, BBadge, BLink } from "bootstrap-vue";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import useVerticalNavMenuLink from "./useVerticalNavMenuLink";
import mixinVerticalNavMenuLink from "./mixinVerticalNavMenuLink";

export default {
    components: {
        BLink,
        BBadge,
        BAvatar,
    },
    mixins: [mixinVerticalNavMenuLink],
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { isActive, linkProps, updateIsActive, counter } = useVerticalNavMenuLink(props.item);
        const { t } = useI18nUtils();
        const { canViewVerticalNavMenuLink } = useAclUtils();

        return {
            isActive,
            linkProps,
            updateIsActive,
            counter,
            // ACL
            canViewVerticalNavMenuLink,
            // i18n
            t,
        };
    },
};
</script>
